import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, observable, runInAction, set } from "mobx";
import { request } from "../utils/request.js";
import { locationRestConsentDelete } from "../wp-api/consent.delete.js";
class Consent {
    get revision() {
        return this.store.revisions.get(this.revision_hash);
    }
    get revision_independent() {
        return this.store.revisionsIndependent.get(this.revision_independent_hash);
    }
    get custom_bypass_readable() {
        const { custom_bypass } = this;
        return custom_bypass ? custom_bypass.charAt(0).toUpperCase() + custom_bypass.slice(1) : "";
    }
    /**
     * Prepare the entry for JSON export.
     */ get export() {
        return JSON.parse(JSON.stringify({
            ...this.plain,
            revision: this.revision.data,
            revision_independent: this.revision_independent.data
        }));
    }
    constructor(consent, store){
        this.busy = false;
        this.delete = flow(function*() {
            this.busy = true;
            try {
                yield request({
                    location: locationRestConsentDelete,
                    params: {
                        id: this.id
                    }
                });
                yield this.store.fetchAll();
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.busy = false;
            }
        });
        runInAction(()=>set(this, consent));
        this.store = store;
        this.plain = consent;
    }
    fetchRevisions() {
        return Promise.all([
            this.store.fetchRevision({
                hash: this.revision_hash
            }),
            this.store.fetchRevisionIndependent({
                hash: this.revision_independent_hash
            })
        ]);
    }
}
_ts_decorate([
    observable
], Consent.prototype, "busy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], Consent.prototype, "id", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "plugin_version", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "design_version", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "ipv4", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "ipv6", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "ipv4_hash", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "ipv6_hash", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "uuid", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "previous_decision", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "decision", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "decision_labels", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "created", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "blocker", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "blocker_thumbnail", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "dnt", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "custom_bypass", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "user_country", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "revision_hash", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "revision_independent_hash", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "button_clicked", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "context", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "viewport_width", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "viewport_height", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "referer", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "url_imprint", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "url_privacy_policy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "forwarded", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "forwarded_blocker", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "previous_tcf_string", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "tcf_string", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "previous_gcm_consent", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "gcm_consent", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "recorder", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Consent.prototype, "ui_view", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Consent.prototype, "revision", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Consent.prototype, "revision_independent", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Consent.prototype, "custom_bypass_readable", null);
export { Consent };
